import React from 'react';
import { 
  HelpCircle, 
  Monitor, 
  Smartphone, 
  Database, 
  Shield, 
  Users, 
  TrendingUp,
  Layers
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Smartphone,
      title: 'Выбор платформы',
      description: 'iOS предлагает ARKit, Android - ARCore. Выбирайте в зависимости от целевой аудитории или рассмотрите кросс-платформенные решения.'
    },
    {
      icon: Monitor,
      title: 'Дизайн для AR',
      description: 'AR-интерфейс должен быть интуитивным, минималистичным и не загораживать реальный мир.'
    },
    {
      icon: Database,
      title: 'Оптимизация 3D',
      description: 'Оптимизируйте 3D-модели для мобильных устройств. Слишком детализированные модели могут снизить производительность.'
    },
    {
      icon: Shield,
      title: 'Тестирование',
      description: 'Тестируйте AR-приложение в различных условиях освещения и на разных устройствах.'
    },
    {
      icon: Layers,
      title: 'Маркеры и безмаркерная AR',
      description: 'Маркерная AR проще в реализации, безмаркерная более универсальна, но требует больше ресурсов.'
    },
    {
      icon: Users,
      title: 'Пользовательский опыт',
      description: 'Учитывайте, что большинство пользователей впервые взаимодействуют с AR. Включите обучающие материалы.'
    },
    {
      icon: TrendingUp,
      title: 'Аналитика',
      description: 'Внедрите аналитику для отслеживания взаимодействия пользователей с AR-контентом и оптимизации UX.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по AR-технологиям
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите детальную консультацию о возможностях AR-технологий для вашего бизнеса от экспертов.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Запросить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;